import {
  Component,
  HostBinding,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core'
import { ComponentSize } from '@wm-front/shared/enums'

@Component({
  selector: 'wm-front-button-group',
  templateUrl: './button-group.component.html',
  styleUrls: ['./button-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class ButtonGroupComponent {
  /** The component size, can be 3 sizes */
  @Input() public size: string

  /** Whether or not the component should have the class 'big'
   * @return { boolean }
   */
  @HostBinding('class.big')
  public get big(): boolean {
    return this.size === ComponentSize.BIG
  }

  /** Whether or not the component should have the class 'medium'
   * @return { boolean }
   */
  @HostBinding('class.medium')
  public get medium(): boolean {
    return this.size === ComponentSize.MEDIUM
  }

  /** Whether or not the component should have the class 'small'
   * @return { boolean }
   */
  @HostBinding('class.small')
  public get small(): boolean {
    return this.size === ComponentSize.SMALL
  }
}
